var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F3F4F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.4C10.5148 6.4 9.09041 6.99 8.0402 8.0402C6.99 9.09041 6.4 10.5148 6.4 12C6.4 12.7354 6.54485 13.4636 6.82627 14.143C7.1077 14.8225 7.52019 15.4398 8.0402 15.9598C8.56021 16.4798 9.17755 16.8923 9.85697 17.1737C10.5364 17.4552 11.2646 17.6 12 17.6C12.7354 17.6 13.4636 17.4552 14.143 17.1737C14.8224 16.8923 15.4398 16.4798 15.9598 15.9598C16.4798 15.4398 16.8923 14.8224 17.1737 14.143C17.4552 13.4636 17.6 12.7354 17.6 12C17.6 10.5148 17.01 9.09041 15.9598 8.0402C14.9096 6.99 13.4852 6.4 12 6.4ZM7.05025 7.05025C8.36301 5.7375 10.1435 5 12 5C13.8565 5 15.637 5.7375 16.9497 7.05025C18.2625 8.36301 19 10.1435 19 12C19 12.9193 18.8189 13.8295 18.4672 14.6788C18.1154 15.5281 17.5998 16.2997 16.9497 16.9497C16.2997 17.5998 15.5281 18.1154 14.6788 18.4672C13.8295 18.8189 12.9193 19 12 19C11.0807 19 10.1705 18.8189 9.32122 18.4672C8.47194 18.1154 7.70026 17.5998 7.05025 16.9497C6.40024 16.2997 5.88463 15.5281 5.53284 14.6788C5.18106 13.8295 5 12.9193 5 12C5 10.1435 5.7375 8.36301 7.05025 7.05025ZM12 8.5C12.3866 8.5 12.7 8.8134 12.7 9.2V11.7101L14.595 13.605C14.8683 13.8784 14.8683 14.3216 14.595 14.595C14.3216 14.8683 13.8784 14.8683 13.605 14.595L11.505 12.495C11.3737 12.3637 11.3 12.1857 11.3 12V9.2C11.3 8.8134 11.6134 8.5 12 8.5Z",
    fill: "#DADCDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingCheck);
export default __webpack_public_path__ + "static/media/pendingCheck.f8679f05b58f919344275c3105420129.svg";
export { ForwardRef as ReactComponent };